import React, { createContext, useContext, useState, useCallback } from 'react';

const RefreshContext = createContext();

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error('useRefresh must be used within a RefreshProvider');
  }
  return context;
};

export const RefreshProvider = ({ children }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(async () => {
    if (isRefreshing) return;
    
    setIsRefreshing(true);
    console.log('🔄 Starting app refresh...');
    
    try {
      // Trigger refresh event for all components
      window.dispatchEvent(new CustomEvent('appRefresh', { 
        detail: { timestamp: Date.now() } 
      }));
      
      // Trigger company data refresh
      window.dispatchEvent(new CustomEvent('userAuthenticated', { 
        detail: { user: JSON.parse(localStorage.getItem('acctoo_user') || '{}') } 
      }));
      
      // Increment refresh key to force re-renders
      setRefreshKey(prev => prev + 1);
      
      // Simulate refresh delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      console.log('✅ App refresh completed');
    } catch (error) {
      console.error('❌ Refresh failed:', error);
    } finally {
      setIsRefreshing(false);
    }
  }, [isRefreshing]);

  const value = {
    isRefreshing,
    refreshKey,
    refresh
  };

  return (
    <RefreshContext.Provider value={value}>
      {children}
    </RefreshContext.Provider>
  );
};

